<header class="flex header">
  <h2>
    @if (deparment) {
      {{ 'Update' | translateWF: 'Update' }}
    } @else {
      {{ 'Add' | translateWF: 'Add' }}
    }
    {{ 'Department' | translateWF: 'Department' }}
  </h2>
  <p-button icon="pi pi-times" (click)="onClose()" />
</header>

<div class="content">
  <p-card [formGroup]="departmentFormGroup">
    <div class="col">
      <div class="row-sm-start-center">
        <i class="pi pi-language"></i>
        {{ 'Common_Spanish_Translate' | translateWF: 'Spanish Translate' }}
        <p-toggleswitch [formControl]="spanishTranslate" />
      </div>
      <div class="form-box" formGroupName="name">
        <label>{{ 'Name' | translateWF: 'Name' }}</label>
        <p-inputgroup>
          <p-inputgroup-addon> EN </p-inputgroup-addon>
          <input pInputText type="text" class="w-full" formControlName="en" />
        </p-inputgroup>
        @if (spanishTranslate.value) {
          <p-inputgroup>
            <p-inputgroup-addon> ES </p-inputgroup-addon>
            <input formControlName="es" pInputText type="text" class="w-full"
          /></p-inputgroup>
        }
      </div>
      <div class="form-box" formGroupName="description">
        <label>{{ 'Description' | translateWF: 'Description' }}</label>
        <p-inputgroup>
          <p-inputgroup-addon> EN </p-inputgroup-addon>
          <textarea
            rows="2"
            cols="30"
            pTextarea
            class="w-full"
            formControlName="en"
            [ngClass]="{
              'ng-invalid ng-dirty': submittedForm && departmentFormGroup.get('description.en')?.invalid,
            }"
          ></textarea>
        </p-inputgroup>
        @if (spanishTranslate.value) {
          <p-inputgroup>
            <p-inputgroup-addon> ES </p-inputgroup-addon>
            <textarea rows="2" cols="30" pTextarea class="w-full" formControlName="es"></textarea>
          </p-inputgroup>
        }
      </div>
      <div class="form-box">
        <label for="members">{{ 'Departments_Table_Members' | translateWF: 'Members' }}</label>
        <p-autoComplete
          fluid
          class="w-full"
          [suggestions]="membersToDisplay"
          [formControl]="members"
          dropdownIcon="pi pi-search"
          [forceSelection]="true"
          optionLabel="username"
          [dropdown]="true"
          (onSelect)="onSelectMember($event)"
          (completeMethod)="searchMember($event)"
        >
          <ng-template let-user pTemplate="item">
            <div class="panel__option mb-2" [title]="user.username">
              {{ user.username }}
            </div>
          </ng-template>
        </p-autoComplete>
        <ng-container *ngFor="let user of membersSelected; let i = index">
          <p-tag [value]="user.username" class="mr-2 my-2">
            <button type="button" class="ml-1 p-button p-button-icon-only p-button-text" (click)="removeMember(i)" pTooltip="Remove">
              <i class="pi pi-times"></i>
            </button>
          </p-tag>
        </ng-container>
      </div>
      <div class="form-box">
        <label for="managers">{{ 'Departments_Table_Managers' | translateWF: 'Managers' }}</label>
        <p-autoComplete
          fluid
          class="w-full"
          [suggestions]="managersToDisplay"
          [formControl]="managers"
          dropdownIcon="pi pi-search"
          [forceSelection]="true"
          optionLabel="username"
          [dropdown]="true"
          (onSelect)="onSelectManager($event)"
          (completeMethod)="searchManager($event)"
        >
          <ng-template let-user pTemplate="item">
            <div class="panel__option mb-2" [title]="user.username">
              {{ user.username }}
            </div>
          </ng-template>
        </p-autoComplete>
        <ng-container *ngFor="let user of managersSelected; let i = index">
          <p-tag [value]="user.username" class="mr-2 my-2">
            <button type="button" class="ml-1 p-button p-button-icon-only p-button-text" (click)="removeManager(i)" pTooltip="Remove">
              <i class="pi pi-times"></i>
            </button>
          </p-tag>
        </ng-container>
      </div>
    </div>
  </p-card>
</div>

<footer>
  <p-button class="w-full" [label]="'Save' | translateWF: 'Save'" (click)="onSubmit()" />
  <p-button class="w-full" [label]="'Exit' | translateWF: 'Exit'" variant="outlined" (click)="onClose()" />
</footer>
